import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { useParams } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ResidentManInfoViewTab from "./ResidentManInfoViewTab";
import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";

function ResidentManInfoView() {
  const navigate = useNavigate();
  const { rid } = useParams();

  // const [residentinfo,setresidentinfo]=React.useState([])
  const [name, setname] = React.useState("");
  async function viewresident() {
    let bodyFormData = "";
    localStorage.setItem("rid", rid);
    makeGetRequest("resident/getalldetails/" + rid, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          // const data = response.data.data;
          setname(
            response.data.data.user_obj.first_name +
              " " +
              response.data.data.user_obj.last_name
          );
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }
  useEffect(() => {
    viewresident();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/ResidentManagement2")}
              />
              {name}
              {/* <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/AddServiceProvider")}
              /> */}
              {/* {residentinfo.user.first_name}  {residentinfo.user.last_name}      */}
            </h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="serviceProViderViewMain">
                <div className="serviceProViderViewInner">
                  <div className="residentContMain">
                    <ResidentManInfoViewTab name={rid} />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default ResidentManInfoView;
